import { Response } from 'datx-jsonapi';
import { useResource, useResourcesInfinite } from 'datx-jsonapi-react';
import { FC, useMemo, useState } from 'react';

import { FilterCombobox } from '@/components/ui/features/speakers/SpeakersFilter/components/FilterCombobox';
import { useQueryParams } from '@/hooks/useQueryParams';
import { IAlgoliaFilterItem } from '@/interfaces/IAlgoliaFilterItem';
import { querySelectedSpeakersFilterEvent, querySpeakersFiltersEventsInfinite } from '@/queries/algolia-filter-item';
import { AlgoliaFilterItem } from '@/resources/AlgoliaFilterItem';
import { extractSWRInfiniteData } from '@/utils/swr/extractSWRInfiniteData';
import { StringParam } from '@/utils/url-query-string';

const defaultSubject: IAlgoliaFilterItem = { label: 'All events', value: null, amount: 0 };

export const FilterEvents: FC = () => {
  const [subjectSearch, setSubjectSearch] = useState('');
  const { slug, event_id, query, change } = useQueryParams<{ slug: string; event_id: string; query: string }>({
    slug: StringParam,
    event_id: StringParam,
    query: StringParam,
  });

  const { data: selectedEvent } = useResource(
    querySelectedSpeakersFilterEvent({
      event_id,
      query,
      selected_resource: 'event',
      selected_id: event_id,
    }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const { data, error, size, setSize } = useResourcesInfinite(
    querySpeakersFiltersEventsInfinite({
      filters: {
        query,
        events_query: subjectSearch,
        visible: 'true',
      },
      pageSize: 20,
    }),
    { revalidateAll: true }
  );

  const { items, isReachingEnd, isLoadingMore } = useMemo(
    () => extractSWRInfiniteData<AlgoliaFilterItem>(data as Array<Response<AlgoliaFilterItem>>, error, size),
    [data, error, size]
  );

  const formatedItems = useMemo(() => {
    return [defaultSubject, ...items];
  }, [items]);

  const onChange = (value) => {
    change({ event_id: value, slug, query }, { method: 'replace', shallow: true });
  };

  return (
    <FilterCombobox
      placeholder="Search"
      itemsList={formatedItems}
      defaultItem={selectedEvent || defaultSubject}
      onChangeItem={(item) => onChange(item?.value)}
      isLoadingMore={isLoadingMore && !isReachingEnd}
      onScrollToBottom={() => {
        if (!error && !isReachingEnd) {
          setSize(size + 1);
        }
      }}
      onSearchChange={(value) => setSubjectSearch(value)}
    />
  );
};
